import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer id="footer" className="bg-muted/50 border-t">
      <div id="footer-container" className="container mx-auto px-4 py-12">
        <div id="footer-grid" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          {/* Company Info */}
          <div id="footer-company-info" className="lg:col-span-2 space-y-4">
            <div className="flex items-center space-x-2">
              <div className="h-8 w-8 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">CA</span>
              </div>
              <span className="font-bold text-lg">Chatslytics Agent Builder</span>
            </div>
            <p className="text-sm text-muted-foreground max-w-md">
              Build, deploy, and monetize AI agents effortlessly. From medical coding to PDF analysis, 
              create specialized AI solutions for your business needs.
            </p>
            <div className="space-y-1">
              <p className="text-xs font-medium">Neirotech AI Private Limited</p>
              <p className="text-xs text-muted-foreground">Registered in Noida, India</p>
              <div className="flex flex-wrap gap-4 text-xs text-muted-foreground">
                <a href="mailto:business@chatslytics.com" className="hover:text-foreground">
                  business@chatslytics.com
                </a>
                <a href="mailto:support@chatslytics.com" className="hover:text-foreground">
                  support@chatslytics.com
                </a>
              </div>
            </div>
          </div>

          {/* Product */}
          <div id="footer-product-section" className="space-y-3">
            <h3 id="footer-product-title" className="text-sm font-semibold">Product</h3>
            <ul id="footer-product-links" className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/marketplace" className="hover:text-foreground">Marketplace</Link></li>
              <li><Link to="/dashboard" className="hover:text-foreground">Dashboard</Link></li>
              <li><Link to="/workflows" className="hover:text-foreground">Workflow Designer</Link></li>
              <li><Link to="/workflow-builder" className="hover:text-foreground">Workflow Builder</Link></li>
              <li><Link to="/pricing" className="hover:text-foreground">Pricing</Link></li>
            </ul>
          </div>

          {/* Account */}
          <div id="footer-account-section" className="space-y-3">
            <h3 id="footer-account-title" className="text-sm font-semibold">Account</h3>
            <ul id="footer-account-links" className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/login" className="hover:text-foreground">Sign In</Link></li>
              <li><Link to="/register" className="hover:text-foreground">Sign Up</Link></li>
              <li><Link to="/forgot-password" className="hover:text-foreground">Reset Password</Link></li>
              <li><Link to="/auth" className="hover:text-foreground">Authentication</Link></li>
            </ul>
          </div>

          {/* Specialized Solutions */}
          <div id="footer-solutions-section" className="space-y-3">
            <h3 id="footer-solutions-title" className="text-sm font-semibold">Solutions</h3>
            <ul id="footer-solutions-links" className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/marketplace?category=healthcare" className="hover:text-foreground">Medical Coding</Link></li>
              <li><Link to="/marketplace?category=document-processing" className="hover:text-foreground">PDF Analysis</Link></li>
              <li><Link to="/marketplace?category=finance" className="hover:text-foreground">Financial Analysis</Link></li>
              <li><Link to="/marketplace?category=customer-service" className="hover:text-foreground">Customer Service</Link></li>
              <li><Link to="/contact" className="hover:text-foreground">Enterprise Solutions</Link></li>
            </ul>
          </div>

          {/* Support & Legal */}
          <div id="footer-support-legal-section" className="space-y-3">
            <h3 id="footer-support-title" className="text-sm font-semibold">Support</h3>
            <ul id="footer-support-links" className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/docs" className="hover:text-foreground">Documentation</Link></li>
              <li><Link to="/api" className="hover:text-foreground">API Reference</Link></li>
              <li><Link to="/contact" className="hover:text-foreground">Help Center</Link></li>
              <li><Link to="/contact" className="hover:text-foreground">Contact Us</Link></li>
              <li><Link to="/unauthorized" className="hover:text-foreground">Access Help</Link></li>
            </ul>
            
            <h4 id="footer-legal-title" className="text-sm font-semibold pt-4">Legal</h4>
            <ul id="footer-legal-links" className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/privacy" className="hover:text-foreground">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-foreground">Terms of Service</Link></li>
              <li><Link to="/refund-policy" className="hover:text-foreground">Refund Policy</Link></li>
              <li><Link to="/about-us" className="hover:text-foreground">About Us</Link></li>
            </ul>
          </div>
        </div>

        <div id="footer-bottom" className="mt-8 pt-8 border-t flex flex-col md:flex-row justify-between items-center">
          <div id="footer-copyright" className="text-xs text-muted-foreground space-y-1">
            <p>&copy; 2023-25 Neirotech AI Private Limited. All rights reserved.</p>
            <p>IIM Lucknow Noida Campus Incubation Program | Google Startup Support Program</p>
          </div>
          <div id="footer-branding" className="flex items-center space-x-4 mt-4 md:mt-0">
            <div className="text-xs text-muted-foreground">
              Powered by AI • Built in India 🇮🇳
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
